/**
 * 店舗の選択肢に出さない店の判定。
 *
 * ヤマダの店舗一覧には配工センター・物流センター・返品センターなど、在庫照合で在庫を入れない拠点が混ざっている。
 * 選んでも在庫が出ないので、絞り込みの選択肢から外す（2026-10-14 ユーザー指定）。
 * 「web.com 千種センター店」「Tecc LIFE SELECT 港北センター店」のように名前に「センター」が付く実店舗は出す。
 */
const HIDDEN_STORE_PATTERN = /配工|物流|返品センター|被災品センター|良品センター|在庫センター|^SPA.*センター$|^本部$/;

export function isHiddenStore(name: string | null | undefined): boolean {
  return HIDDEN_STORE_PATTERN.test((name ?? '').trim());
}
